import React, { useState } from "react";
import { InterviewSidebarSection } from "../Components/InterviewSidebarSection";
import { AddAdditional } from "@coverme/forms";
import { AddNoteModal } from "../../../../components/Notes/AddNoteModal";
import { LoadingBar } from "../../../../components/LoadingComponents/LoadingBar";
import { toast } from "react-toastify";
import { NoteItem } from "../../../../components/Notes/MiniFacesheetNotes";

export const InterviewSidebarNotes = ({ notes = [], addNote, getNotes, personId, customerCode, ...props }) => {
    const [isModalShown, setIsModalShown] = useState(false);
    let notesCount = notes?.length || 0;
    function onNoteAdded(noteBody) {
        if (customerCode !== undefined) {
            return addNote(customerCode, personId, noteBody).then(() => {
                toast.success("Note added successfully");
                return getNotes(customerCode, personId);
            });
        }
    }

    return (
        <InterviewSidebarSection title={`Notes`} {...props} expandable={false}>
            {notes.map(x => (
                <NoteItem {...x} key={x.GlobalId} lengthToTruncate={30} />
            ))}
            {notes.length === 0 && <p className="no-notes-found">No notes found</p>}
            <AddAdditional clickEvent={() => setIsModalShown(true)} labelText={"Add Note"} />
            <AddNoteModal onNoteAdded={onNoteAdded} onClose={() => setIsModalShown(false)} isShown={isModalShown} />
        </InterviewSidebarSection>
    );
};
